import { render, staticRenderFns } from "./employee-top-panel.vue?vue&type=template&id=37f773ff&"
import script from "./employee-top-panel.vue?vue&type=script&lang=js&"
export * from "./employee-top-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports